import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import Footer from "./footer"
import '../styles/index.scss'
import {Container, Row, Col, Card} from "reactstrap"

const Layout = ({children, pageTitle }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          logo
        }
      }
    }
  `)

  return (
    <>      
    <Container>
      <Row>
        <Col>
          <Card className="containerCard">
            <Container id="content">
              <Row>
                <Col md="12">
                  <Header siteTitle={data.site.siteMetadata.title}/>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <h1 className="pageTitle">{pageTitle}</h1>
                </Col>
              </Row>        
              <Row>
                <Col md="12">                
                  {children}
                </Col>
              </Row>
              <Footer/>
            </Container>      
        </Card>
        </Col>
      </Row>
    </Container>
    
      <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.6.3/css/all.css"></link>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout